export default {
  path: '/oauth-error',
  // TODO component: () => import('./pages/Error')
  redirect: '/'
}
